import {useContext} from 'react';
import {PageTitleContext} from '@/contexts/PageTitleContext';

export const usePageTitle = () => useContext(PageTitleContext);
